<template>
  <nav class="menu">
    <a href="/xy_web/" class="m_logo">
      <img src="../../assets/logo_white.png" alt="" :class="{logoshow:true}" v-if="isproject" />
      <img src="../../assets/logo_black.png" alt="" :class="{logoshow:(imgbool>0?true:false)}" v-else />
    </a>
    <a href="/xy_web/project_list.html">作品</a>
    <a href="/xy_web/about/introduction.html">关于我们</a>
    <a href="/xy_web/news.html">新闻</a>
    <a href="/xy_web/job.html">加入团队</a>
    <a href="/xy_web/contact.html">联系我们</a>
  </nav>
</template>

<script>
  export default {
    name: "Menu",
    props: ["imgbool", "isproject"],
    data: function() {
      return {

      }
    },
    mounted: function() {
      //console.log("imgbool: " + this.imgbool);
    },
    watch: {
      imgbool: function() {
        if (this.imgbool > 0) {
          let hctLeft = this.getEleOffsetLeft(".hct");
          let menuLeft = this.getEleOffsetLeft(".menu");
          if (hctLeft && menuLeft) {
            this.getEleDom(".m_logo img").style.marginLeft = (hctLeft - menuLeft) + "px";
          }
        }
      }
    },
    methods: {
      getEleDom: function(str) {
        let dom = document.querySelectorAll(str)[0];
        if (this.isEle(dom)) {
          return dom;
        } else {
          return undefined;
        }
      },
      isEle: function(dom) {
        if (dom) {
          return (dom.nodeType == 1) ? true : false;
        } else {
          return false;
        }
      },
      getEleOffsetLeft: function(ele) {
        let dom = this.getEleDom(ele);
        return dom ? dom.offsetLeft : null;
      }
    }
  }
</script>

<style lang="less">
  .header_content {
    .menu {
      width: 95.833vw;
      border: solid thin white;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 auto;

      a {
        font-family: "SSHei";
        font-size: 1.3125em;
        color: white;
        display: block;
        margin: 0;
        padding: 0.619em 0;
        width: 15.217%;
        text-align: center;
        text-decoration: none;
        transition: color 0.2s ease, background-color 0.2s ease;

        &:hover {
          color: black;
          background-color: white;
        }
      }

      a.m_logo {
        width: 22.213%;
        padding: 0;
        flex-grow: 1;

        img {
          /* height: 1.3125em; */
          height: 1.257vw;
          display: none;
          margin: 0 auto;
        }

        &:hover {
          background-color: transparent;
        }

        .logoshow {
          display: block;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/Menu.vue